import useScrollDirection from "@hooks/useScrollDirection"
import { RefObject, useEffect, useState } from "react"

const useStickySearch = (
  searchBarRef: RefObject<HTMLElement>,
  onScrollUp?: boolean
) => {
  const [searchBarTop, setSearchBarTop] = useState<number | undefined>(
    undefined
  )
  const [searchBarHeight, setSearchBarHeight] = useState<number | undefined>(
    undefined
  )

  const scrollDirection = useScrollDirection({})

  // hook to get search bar top position on page load
  useEffect(() => {
    if (searchBarRef.current) {
      setSearchBarTop(searchBarRef.current.offsetTop)
      setSearchBarHeight(searchBarRef.current.offsetHeight)
    }
  }, [searchBarRef])

  // hook to make search bar sticky on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (!searchBarTop || !searchBarHeight) return
      if (searchBarRef.current) {
        if (window.scrollY > searchBarTop) {
          searchBarRef.current.style.position = "sticky"
          if (scrollDirection === "down" && onScrollUp) {
            searchBarRef.current.style.transitionDelay = "500ms"
            searchBarRef.current.style.transform = `translateY(-${
              10 + Number(searchBarHeight)
            }px)`
          } else {
            searchBarRef.current.style.transitionDelay = "0ms"
            searchBarRef.current.style.transform = "translateY(0)"
          }
        } else {
          searchBarRef.current.style.position = "relative"
          searchBarRef.current.style.transform = "translateY(0)"
        }
      }
    }
    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [searchBarTop, scrollDirection, searchBarHeight, searchBarRef, onScrollUp])
}

export default useStickySearch
